import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface SidebarState {
  isOpen: boolean;
  toggle: () => void;
  reset: () => void;
}

const useSidebarStore = create<SidebarState>()(
  devtools(
    persist(
      (set) => ({
        isOpen: true,
        toggle: () => set((state) => ({ isOpen: !state.isOpen })),
        reset: () => set({ isOpen: true }),
      }),
      {
        name: 'sidebar-storage', // unique name for storage
      },
    ),
  ),
);

export default useSidebarStore;
